import { ApplicationsAction, ApplicationsActionType } from './Applications.action-types';
import { IApplicationsState } from './Applications.types';

const initialState: IApplicationsState = {
    applications: null,
    isLoading: false,
    errorMessage: null,
};

export function applicationsReducer(
    state: IApplicationsState = initialState,
    action: ApplicationsAction
): IApplicationsState {
    switch (action.type) {
        case ApplicationsActionType.REQUEST_APPLICATIONS:
            return {
                ...state,
                isLoading: true,
            };
        case ApplicationsActionType.RECEIVE_APPLICATIONS:
            return {
                ...state,
                isLoading: false,
                errorMessage: null,
                applications: action.applications,
            };
        default:
            return state;
    }
}
